export const MARKET_REPORTS_PERMISSIONS = {
  pageId: 69,
  name: 'Market Reports',
  path: 'market-reports',
  sections: {
    1: {
      name: 'Edit Reports',
      sectionId: 9,
      path: 'market-reports',
    },
    2: {
      name: 'Edit Companies',
      sectionId: 14,
      path: 'market-companies',
    },
  },
} as const;
